import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-finalize-investments-confirmation-dialog',
  templateUrl: './finalize-investments-confirmation-dialog.component.html',
  styleUrls: ['./finalize-investments-confirmation-dialog.component.scss'],
})
export class FinalizeInvestmentsConfirmationDialogComponent implements OnInit {
  @Input() entity: any;
  data: any;

  ngOnInit(): void {
    this.data = this.entity;
  }

  getInvestorName(investment: any): string {
    const user = investment?.user;
    const names = user?.names ?? investment?.names;
    const familyNames = user?.familyNames ?? investment?.familyNames;
    return `${names || ''} ${familyNames || ''}`.trim();
  }

  getInvestmentAmount(investment: any): number {
    const rawAmount = investment?.amount ?? 0;
    return this.toNumber(rawAmount);
  }

  toNumber(value: any): number {
    const normalized = Number(
      String(value ?? 0)
        .replace(/\s/g, '')
        .replace(/,/g, '')
    );

    return Number.isNaN(normalized) ? 0 : normalized;
  }
}
